// extracted by mini-css-extract-plugin
export default {"menuBlock":"zG-z","title":"AG-z","nav":"BG-z","flexCell":"CG-z","facetLink":"DG-z"};